import { LOCAL_STORAGE_NAME } from 'js/constants/App';
let screenName = 'Home';

export const setScreenName = (name) => {
  console.log('Setting screen name to:', name);
  screenName = name;
};

export const trackPwaInstallEvent = () => {
  if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true) {
    const hasTracked = localStorage.getItem(`${LOCAL_STORAGE_NAME}:pwa-install-tracked`);
    if (hasTracked) {
      console.log('PWA install event already tracked, skipping.');
      return;
    }

    trackEvent('game_pwa_install');
    localStorage.setItem(`${LOCAL_STORAGE_NAME}:pwa-install-tracked`, 'true');
  }
};

export const trackEvent = (name, parameters = {}) => {
  if (JW_WATCH) {
    return;
  }

  const event = {
    event: name,
    game_name: 'Game_Sesame Outdoor Learning Hub',
    ...parameters,
  };
  if (screenName) {
    event.screen_name = screenName;
  }
  console.log('Tracking event:', event);
  window?.dataLayer?.push(event);
};
